class deductionListCtrl {
    constructor($scope, httpRequest, initSortService) {
        const now = new Date()
        const curmonth = now.getMonth() + 1
        const curDay = now.getDate()
        const curmonthStr = (curmonth) < 9 ? `0${curmonth}` : curmonth
        const curDayStr = (curDay) < 9 ? `0${curDay}` : curDay

        $scope.tabType = 1 // 默认为明细tab页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                departmentName: '',
                expenseEnd: `${now.getFullYear()}-${curmonthStr}-${curDayStr}`,
                expenseStart: `${now.getFullYear()}-01-01`,
            },
        }

        $scope.tabClick = function tabClick(val) {
            $scope.tabType = val
            if (val == 1) {
                $scope.queryListInfo()
            } else {
                $scope.querytotal()
            }
        }
        // 树组件参数
        $scope.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
        }
        function buildTree(list, rootId) {
            // 适配树组件数据结构
            function recursion(data, pid) {
                const result = []
                let temp
                for (const i in data) {
                    if (data[i].parentId == pid) {
                        result.push(data[i])
                        temp = recursion(data, data[i].departmentId)
                        if (temp.length > 0) {
                            data[i].children = temp
                        }
                    }
                }
                return result
            }
            return recursion(list, rootId)
        }
        httpRequest.get_getDeparmentOfOrg().then((res) => {
            // 缓存原始列表
            const resVal = res.data.value // 目前无层级关系，制造出上下层
            resVal.forEach((element) => {
                element.parentId = '0000'
            })
            resVal.unshift({
                departmentCode: null,
                departmentId: '0000',
                departmentName: '全部部门',
                parentId: -1,
            })
            // 机构树
            $scope.orgTree = buildTree(resVal, -1)
            $scope.defaultNode = $scope.orgTree[0]
            $scope.expandedNodes = resVal.slice(0, 1)
            // console.log($scope.expandedNodes)
            $scope.showSelected($scope.defaultNode)
        })

        // 点击查询机构信息表
        $scope.showSelected = function showSelected(node) {
            $scope.currentOrgItem = node
            $scope.param.param.departmentName = node.departmentName
            $scope.queryListInfo()
        }
        // 查询报销类型
        $scope.reimburseType = []
        httpRequest.get_getIvatBxPzDTOList(false).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                $scope.reimburseType.push(obj)
            }
        })
        $scope.exportReport = function () {
            httpRequest.get_exportDeductions({
                accessToken: localStorage.getItem('id_token'),
                ...$scope.param.param,
            })
        }

        // 表头排序
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            // sessionStorage.setItem('deductionReportParam', JSON.stringify($scope.param))
            $scope.queryListInfo()
        }
        // 查询列表
        $scope.queryListInfo = function () {
            // $scope.param = sessionStorage.deductionReportParam ? JSON.parse(sessionStorage.deductionReportParam) : $scope.param
            if ($scope.param.param.departmentName == '全部部门') {
                $scope.param.param.departmentName = ''
            }
            httpRequest.post_qryDeductionStatisticsDetails($scope.param).then((res) => {
                if (res.data.value.list.length) {
                    $scope.mxListData = res.data.value.list // 后台计算好总计金额 税额 放到明细最后一行
                    const popped = $scope.mxListData.pop()
                    $scope.totalAmt = popped.amount
                    $scope.totalAdtax = popped.deductionTaxAmt
                    $scope.totalTurnOut = popped.turnoutTaxAmt
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                } else {
                    $scope.mxListData = []
                    $scope.totalItems = 0
                    $scope.totalAmt = 0
                    $scope.totalAdtax = 0
                    $scope.totalTurnOut = 0
                }
            })
        }
        // $scope.queryListInfo()
        // 汇总查询
        $scope.querytotal = function () {
            const obj = {
                departmentName: '',
                expenseEnd: $scope.param.param.expenseEnd,
                expenseStart: $scope.param.param.expenseStart,
            }
            httpRequest.post_qryDeductionStatisticsSummary(obj).then((res) => {
                $scope.totalDatalist = res.data.value.deductionList
                $scope.totalAmt = res.data.value.total.amount
                $scope.totalAdtax = res.data.value.total.deductionTaxAmt
                $scope.totalTurnOut = res.data.value.total.turnoutTaxAmt
            })
        }
        $scope.searchList = function () {
            if ($scope.tabType == 1) {
                $scope.queryListInfo()
            } else {
                $scope.querytotal()
            }
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            $scope.queryListInfo()
        }
    }
}

deductionListCtrl.$inject = ['$scope', 'httpRequest', 'initSortService']
export default deductionListCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/deduction/deductReportCtrl.js